<template>
  <div id="onboarding-signature" class="fade-in">
    <StepInfo :showIcon="false" btnText="Ver contrato" @btnClick="actionEvent">
      <h4> Para continuar você deve assinar o contrato de financiamento da compra </h4>

      <ul class="signature">
        <li>
          <div> Total a pagar </div>
          <span>{{ moneyFilter(totalAmount) }}</span>
        </li>
        <li v-if="transactionDownPaymentValue">
          <div> Entrada </div>
          <span>{{ moneyFilter(transactionDownPaymentValue) }}</span>
        </li>
        <li>
          <div> Parcelamento </div>
          <span>{{
            `${numberOfInstallments}x de ${moneyFilter(paymentInstallments)}`
          }}</span>
        </li>
        <li>
          <div> Vencimento da primeira parcela </div>
          <span>{{ dateFilter(firstPaymentDate) }}</span>
        </li>
        <li>
          <div> Vencimento da última parcela </div>
          <span>{{ dateFilter(lastPaymentDate) }}</span>
        </li>
      </ul>
    </StepInfo>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment-timezone';
import StringMixin from '@/mixins/string';
import StepInfo from '../components/StepInfo.vue';

const timezone = 'America/Sao_Paulo';

export default {
  name: 'onboarding-signature',
  mixins: [StringMixin],
  components: { StepInfo },
  methods: {
    ...mapActions('onboardingV2', ['setLoading']),
    async actionEvent() {
      this.setLoading({ loading: true });
      await this.handleNextStep();
      this.setLoading({ loading: false });
    },
    async handleNextStep() {
      this.$router.replace({
        name: 'onboarding-signature-contract-view',
        query: this.$route.query,
      });
    },
  },
  computed: {
    ...mapState('onboarding', ['totalAmount',
      'numberOfInstallments',
      'paymentInstallments',
      'createdAt',
      'hasGracePeriod',
      'gracePeriodDueDate',
      'downPaymentDueDate',
      'transactionDownPaymentValue']),
    firstPaymentDate() {
      if (!this.hasGracePeriod) {
        return moment(this.createdAt).tz(timezone).add(1, 'month').toDate()
          .toISOString();
      }
      return moment(this.gracePeriodDueDate).tz(timezone)
        .toISOString();
    },
    lastPaymentDate() {
      return moment(this.firstPaymentDate).tz(timezone)
        .add(this.numberOfInstallments - 1, 'month').toDate()
        .toISOString();
    },
  },
};
</script>

<style lang="scss" scoped>
  #onboarding-signature {
    h4 {
      color: var(--gray-900);

      font-size: 24px;
      line-height: 32px;
      font-weight: 700;
    }
  }

  .signature li {
    margin: 20px 0 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0em;

    div {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      color: #64748B;
    }
  }
</style>
